module.exports = __webpack_public_path__ + "fdb77ef07d769a3a1f356bb7dbf358af.MP3";